var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 117.67 226.58"}},[_c('path',{attrs:{"d":"M76.38 226.58V123.23h34.69L116.26 83H76.38V57.23c0-11.66 3.23-19.61 20-19.61h21.33v-36A285.15 285.15 0 0086.59 0C55.84 0 34.78 18.77 34.78 53.24V83H0v40.28h34.78v103.3z","data-name":"Layer 2"}})])};var toString = function () {return "/Users/danny/Documents/projects/se-ssd-report/src/assets/social-facebook.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/assets/social-facebook.svg
// module id = VTh/
// module chunks = 0